/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * List of escalations generated during submission
 * @export
 * @interface Escalations
 */
export interface Escalations {
}

/**
 * Check if a given object implements the Escalations interface.
 */
export function instanceOfEscalations(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EscalationsFromJSON(json: any): Escalations {
    return EscalationsFromJSONTyped(json, false);
}

export function EscalationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Escalations {
    return json;
}

export function EscalationsToJSON(value?: Escalations | null): any {
    return value;
}

